import dayjs from 'dayjs';

const DAY = 'day';
const MONTH = 'month';
const DATEVIEW = 'DD/MM/YYYY';

export const getDatesOfLastSevenDays = (): dayjs.Dayjs[] => {
	const dates: dayjs.Dayjs[] = [];
	const today = dayjs();
	for (let i = 0; i < 7; i++) {
		const date = today.subtract(i, DAY);
		const isoDate = date.toISOString();
		dates.push(dayjs(isoDate));
	}
	return dates.reverse();
};

export const getDatesOfLastSevenDaysLabels = (): string[] => {
	const dates = [];
	const today = dayjs();
	for (let i = 0; i < 7; i++) {
		const date = today.subtract(i, DAY);
		const formattedDate = date.format(DATEVIEW);
		dates.push(formattedDate);
	}
	return dates.reverse();
};

export const getDatesOfLastThirtyDays = (): dayjs.Dayjs[] => {
	const dates = [];
	const today = dayjs();
	for (let i = 0; i < 30; i++) {
		const date = today.subtract(i, DAY);
		const isoDate = date.toISOString();
		dates.push(dayjs(isoDate));
	}
	return dates.reverse();
};

export const getDatesOfLastThirtyDaysLabels = (): string[] => {
	const dates = [];
	const today = dayjs();
	for (let i = 0; i < 30; i++) {
		const date = today.subtract(i, DAY);
		const formattedDate = date.format(DATEVIEW);
		dates.push(formattedDate);
	}
	return dates.reverse();
};

export const getDatesOfLastTwelveMonths = (): dayjs.Dayjs[] => {
	const dates = [];
	const today = dayjs();
	for (let i = 0; i < 12; i++) {
		const date = today.subtract(i, MONTH).endOf(MONTH);
		const isoDate = date.toISOString();
		dates.push(dayjs(isoDate));
	}
	return dates.reverse();
};

export const getDatesOfLastTwelveMonthsLabels = (): string[] => {
	const dates = [];
	const today = dayjs();
	for (let i = 0; i < 12; i++) {
		const date = today.subtract(i, MONTH).endOf(MONTH);
		const formattedDate = date.format(DATEVIEW);
		dates.push(formattedDate);
	}
	return dates.reverse();
};

export const formatDateDay = (dateString: string): dayjs.Dayjs => {
	const date = dayjs(dateString);
	return dayjs(date.toISOString());
};

export const areDatesSameMonthAndYear = (date1: dayjs.Dayjs, date2: dayjs.Dayjs): boolean => {
	const month1 = date1.month();
	const month2 = date2.month();
	const year1 = date1.year();
	const year2 = date2.year();

	return month1 === month2 && year1 === year2;
};

export const isDateOlder = (date1: dayjs.Dayjs, date2: dayjs.Dayjs): boolean => date1.isBefore(date2);

export const areDatesEqual = (date1: dayjs.Dayjs, date2: dayjs.Dayjs): boolean => date1.isSame(date2, DAY);
